import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentDoctor } from "../../authDoctor/redux/thunks/doctorsThunks";
import {
  fetchPrescriptionLayout,
  savePrescriptionLayout,
} from "../redux/thunks/prescriptionLayoutThunks";
import {
  selectPrescriptionLayout,
  selectPrescriptionLayoutStatus,
  selectPrescriptionLayoutError,
  selectPrescriptionLayoutSaveStatus,
  selectPrescriptionLayoutSaveError,
} from "../redux/slices/prescriptionLayoutSlice";

export function usePrescriptionLayout() {
  const dispatch = useDispatch();

  const {
    user: currentDoctor,
    loading: doctorLoading,
    error: doctorError,
  } = useSelector((state) => state.doctor || {});

  const layout = useSelector(selectPrescriptionLayout);
  const status = useSelector(selectPrescriptionLayoutStatus);
  const error = useSelector(selectPrescriptionLayoutError);
  const saveStatus = useSelector(selectPrescriptionLayoutSaveStatus);
  const saveError = useSelector(selectPrescriptionLayoutSaveError);

  useEffect(() => {
    dispatch(getCurrentDoctor());
  }, [dispatch]);

  useEffect(() => {
    if (currentDoctor?.id && status === "idle") {
      dispatch(fetchPrescriptionLayout(currentDoctor.id));
    }
  }, [currentDoctor?.id, status, dispatch]);

  // ✅ Sauvegarder le layout + champs doctor
  const saveLayout = useCallback(
    (payload) => {
      if (!currentDoctor?.id) return;

      const {
        logoUrl,
        couleurTexte,
        couleurLogo,
        description,
        active,

        // ✅ NEW doctor fields (format plat)
        fullName,
        fullNameAr,
        specialty,
        specialtyAr,
        phone,
        email,
        address,
        addressAr,
      } = payload || {};

      return dispatch(
        savePrescriptionLayout({
          doctorId: currentDoctor.id,
          layout: {
            logoUrl: logoUrl ?? null,
            couleurTexte,
            couleurLogo,
            description: description ?? null,
            active: active ?? true,

            // ✅ forward vers thunk → gateway → MS
            fullName: fullName ?? null,
            fullNameAr: fullNameAr ?? null,
            specialty: specialty ?? null,
            specialtyAr: specialtyAr ?? null,
            phone: phone ?? null,
            email: email ?? null,
            address: address ?? null,
            addressAr: addressAr ?? null,
          },
        })
      );
    },
    [dispatch, currentDoctor?.id]
  );

  return {
    currentDoctor,
    doctorLoading,
    doctorError,
    layout,
    status,
    error,
    saveStatus,
    saveError,
    saveLayout,
  };
}


